import { Settings, TenantSettings } from '@xeetr/types/models'

import { parseSettings } from '../utils/request/settingsMapper'

import ApiService from './common/API.service'


export class SettingsService extends ApiService {
  getSettings = async (): Promise<Settings> => {
    const req = await this.get<Settings>(this.buildCommonUrl('settings'))
    return parseSettings(req)
  }

  putSettings = async (settings: Settings): Promise<Settings> => {
    const req = await this.put<Settings>(this.buildCommonUrl('settings'), settings)
    return parseSettings(req)
  }

  patchSettings = async (partialSettings: Partial<TenantSettings>): Promise<Settings> => {
    const req = await this.patch<TenantSettings>(this.buildCommonUrl('settings'), partialSettings)
    return parseSettings(req)
  }
}
